export default __webpack_public_path__ + "static/media/entertainment.b084e744.svg";